import React, { useState } from 'react';
import Sidebar from '../components/SideBar';
import CreateUserForm from '../components/CreateuserRegistration';
import AssignUserForm from '../components/AssignUserToWebsite';
// import RemoveUserForm from '../components/RemoveUserForm';

const AdminDashboard = () => {
  const [selected, setSelected] = useState('create');

  const renderContent = () => {
    switch (selected) {
      case 'create':
        return <CreateUserForm />;
      case 'assign':
        return <AssignUserForm />;
    //   case 'remove':
    //     return <RemoveUserForm />;
      default:
        return <div>Select a menu</div>;
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar selected={selected} onSelect={setSelected} />
      <div style={{ flex: 1, padding: '20px' }}>
        {renderContent()}
      </div>
    </div>
  );
};

export default AdminDashboard;
